import { Injectable } from '@angular/core';
import { Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import {HttpClientService} from '../http.client.service';
import {API} from '../constants';

@Injectable()
export class UploadFileService {

  progress$;
  progressObserver;
  progress;

  constructor(
    private httpClientService: HttpClientService
  ) {
    this.progress$ = Observable.create(observer => {
      this.progressObserver = observer;
    }).share();
  }

  makeFileRequest(file: any, fileOptions: any, mediaName: boolean) {
    const storage = JSON.parse(sessionStorage.getItem('user')).storage;

    return Observable.create(observer => {
      const formData: FormData = new FormData();
      const xhr: XMLHttpRequest = new XMLHttpRequest();

      if (mediaName) {

        formData.append('', file);
        formData.append('mediaInfo', JSON.stringify(fileOptions));

        xhr.open('POST', API.ENDPOINT.MEDIA.UPLOADTHUMB, true);

      } else {

        formData.append('', file, file.name);
        formData.append('mediaInfo', JSON.stringify(fileOptions));

        xhr.open('POST', API.ENDPOINT.MEDIA.UPLOADFILE, true);
        // xhr.open('PUT', `${storage.endpoint}/${file.name}`);
        // xhr.withCredentials = true;
        // xhr.setRequestHeader('x-auth-token', storage.xSubjectToken);
      }

      xhr.timeout = 1200000;

      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            observer.next(JSON.parse(xhr.response));
            observer.complete();
          } else {
            observer.error(xhr.response);
          }
        }
      };

      xhr.upload.onprogress = (event) => {
        this.progress = Math.round(event.loaded / event.total * 100);

        this.progressObserver.next(this.progress);
      };
      // xhr.send(file);
      xhr.send(formData);
    });
  }

  // TODO: DELETE
  makeFileRequestWithBase64(file: any) {
    return Observable.create(observer => {
      let xhr: XMLHttpRequest = new XMLHttpRequest();
      let data = JSON.stringify(file);

      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            observer.next(JSON.parse(xhr.response));
            observer.complete();
          } else {
            observer.error(xhr.response);
          }
        }
      };

      xhr.upload.onprogress = (event) => {
        this.progress = Math.round(event.loaded / event.total * 100);

        this.progressObserver.next(this.progress);
      };

      xhr.open('POST', API.ENDPOINT.MEDIA.UPLOAD, true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.send(data);
    });
  }

  /**
   * create()
   * @param {any} file - File from input
   */
  create(file: any, fileOptions: any) {
    let formData: FormData = new FormData();
    formData.append('upload', file, file.name);

    let headers = new Headers();
    headers.set('Accept', 'application/json');
    let options = new RequestOptions({ headers: headers });

    return this
      .httpClientService
      .postMedia(API.ENDPOINT.MEDIA.UPLOAD, formData, options)
      .toPromise()
      .then((response) => {
        var media = response.json();

        let result = {
          mediaId: media.media._id,
          name: file.name,
          contentType: file.type,
          order: fileOptions.order,
          mediaFrameId: '',
          isNew: true
        };

        return result;
      })
      .catch(this.handleError);
  }

  /**
   * delete()
   * @param {string} fileId - Id of file to be deleted
   */
  deleteMedia(media: any) {
    let headers = new Headers();
    headers.set('Content-Type', 'application/json');
    let options = new RequestOptions({
      headers: headers,
      body: JSON.stringify(media)
    });

    return this
      .httpClientService
      .deleteMedia(`${API.ENDPOINT.MEDIA.DELETE}`, options)
      .toPromise()
      .then((response) => {
        return response.json();
      })
      .catch(this.handleError);
  }

  getMidia(id: string) {
    let headers = new Headers();
    headers.set('Accept', 'application/json');
    let options = new RequestOptions({ headers: headers });

    return this
      .httpClientService
      .getMedia(`${API.ENDPOINT.MEDIA.GET}${id}`, options)
      .toPromise()
      .then((response) => {
        return response.json().media;
      })
      .catch(this.handleError);
  }

  private handleError(error: Response)  {
    let msg = `Status code ${error.status} on url ${error.url}`;
    console.error(msg);
    return Observable.throw(msg);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/form-media/upload-file.service.ts